import { useMemo } from 'react';
import { useEnabledModules } from '@/hooks/useEnabledModules';
import { useProviderSegment } from '@/hooks/useProviderSegment';
import { buildProviderCapabilities, isProviderPathAllowed } from '@/lib/provider-capabilities.mjs';

export function useProviderCapabilities() {
  const provider = useProviderSegment();
  const tenant = useEnabledModules();

  const capabilities = useMemo(
    () => buildProviderCapabilities({
      providerModules: provider.modules,
      tenantModules: tenant.enabledModules,
      moduleConfigs: tenant.moduleConfigs,
      hasTeam: provider.hasTeam,
    }),
    [provider.modules, provider.hasTeam, tenant.enabledModules, tenant.moduleConfigs],
  );

  const ready = provider.ready && tenant.ready && !provider.isError && !tenant.isError;

  return {
    capabilities,
    ready,
    isLoading: provider.isLoading || tenant.isLoading,
    isError: provider.isError || tenant.isError,
    isPathAllowed: (path: string) => ready && isProviderPathAllowed(path, capabilities),
  };
}
